import axios from 'axios'
import AppSettings from '../AppSettings'

export default () => {
  return axios.create({
    baseURL: AppSettings.API_ENDPOINT,
    withCredentials: false,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  })
}
